// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"23610d70","57":"fbaf0429","960":"1a2814d5"}[chunkId] + ".chunk.js";
};